import { useContext } from "react";

import { DataDisplayContext } from "~/contexts/data-display-context";

export const useDataDisplay = () => useContext(DataDisplayContext);
